import type { SVGAttributes } from "react";
import { cn } from "../helpers/class-names";

type SidebarToggleIconProps = SVGAttributes<SVGSVGElement> & {
  collapsed: boolean;
};

export function SidebarToggleIcon({
  className,
  collapsed,
  ...props
}: SidebarToggleIconProps) {
  return (
    <svg
      className={cn("ui-sidebar-toggle-icon", className)}
      data-collapsed={collapsed}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      focusable="false"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      {...props}
    >
      <path d="M21.25 6.72v10.56a2.97 2.97 0 0 1-2.97 2.97H5.72a2.97 2.97 0 0 1-2.97-2.97V6.72a2.97 2.97 0 0 1 2.97-2.97h12.56a2.97 2.97 0 0 1 2.97 2.97" />
      <path className="ui-sidebar-toggle-icon__divider" d="M6.25 7.25v9.5" />
    </svg>
  );
}
